/**
 * Per-job-family variations of TableRow's account label and secondary
 * column. Sync/Webhook/Email jobs carry `plan`/`email` on job.data; ICS
 * Update/Clean jobs carry `organization_name`/`calendar_name` instead (see
 * App\Utility\QueueICS on the backend) — no plan, no account email.
 */
import { PLAN_NAMES } from "../../../../consts";

export const accountLabelByPlan = (data) => PLAN_NAMES[data.plan];
export const accountLabelByOrganization = (data) => data.organization_name;

export const emailColumn = { header: "Email", render: (data) => data.email };
export const calendarColumn = { header: "Calendar", render: (data) => data.calendar_name };
